import { lazy } from "@bridgesplit/ui";

const AccountSettings = lazy(() => import("./AccountSettings"));

export { AccountSettings };
